import { ReactElement } from "react";
import { IFormHandler } from "client/Forms";
import { localize } from "client_legacy/ndaw/culture";
import { ActivityFeedSettingsState } from "./NotificationSettingsDialog";
import { NotificationSection } from "./NotificationSection";
import { resolveFormattedTextString } from "client/Misc/utils";

export type ExternalActivitySectionProps = {
	formHandler: IFormHandler<ActivityFeedSettingsState>;
};

export const ExternalActivitySection = (props: ExternalActivitySectionProps): ReactElement => {
	const { formHandler } = props;

	return (
		<NotificationSection
			title={localize("_External")}
			trackingId="external"
		>
			<NotificationSection.ItemList>
				{formHandler.for("customActivityTags").map(tagItemHandler => {
					const { value } = tagItemHandler.for("tag");

					return (
						<NotificationSection.Item
							subtext={resolveFormattedTextString({
								template: localize("_ExternalActivityDescription"),
								replacements: [
									{
										what: "{{Name}}",
										filler: value
									}
								]
							})}
							key={value}
							label={value}
							attachable={tagItemHandler.for("isEnabled").attachToCheckbox()}
						/>
					);
				})}

				{formHandler.for("customActivitiesWithoutTags").whenSet(customActivitiesWithoutTagsHandler => (
					<NotificationSection.Item
						subtext={resolveFormattedTextString({
							template: localize("_ExternalActivityDescription"),
							replacements: [
								{
									what: "{{Name}}",
									filler: localize("_Other")
								}
							]
						})}
						label={localize("_Other")}
						attachable={customActivitiesWithoutTagsHandler.for("isEnabled").attachToCheckbox()}
					/>
				))}
			</NotificationSection.ItemList>
		</NotificationSection>
	);
};

ExternalActivitySection.displayName = "ExternalActivitySection";
